// @flow

export const SYSTEM_TAG_KEY = '__system_import';
export const SYSTEM_TAG_ID = 1;
